import styled from 'styled-components';
import Vimeo from '@u-wave/react-vimeo';

export const Container = styled.div<{ $isFullscreen?: boolean }>`
  position: relative;
  display: block;
  width: 100%;
  overflow: ${p => p.$isFullscreen ? 'visible' : 'hidden'};

  &::before {
    display: ${p => p.$isFullscreen ? 'none' : 'block'};
    content: "";
    padding-top: 56.25%;
  }
`;

export const VideoFrame = styled(Vimeo)`
  iframe {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
`;

export const HorizontalThumbnail = styled.img`
  display: block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;
